// extracted by mini-css-extract-plugin
export default {"list":"Comments_list__lC81j","item":"Comments_item__DpG1s","author":"Comments_author__6I9a8","comment":"Comments_comment__oUNau"};